var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectordeleteTsk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 33H27V15H33M33 45H27V39H33M30 0C26.0603 0 22.1593 0.775973 18.5195 2.28361C14.8797 3.79125 11.5726 6.00104 8.7868 8.7868C3.1607 14.4129 0 22.0435 0 30C0 37.9565 3.1607 45.5871 8.7868 51.2132C11.5726 53.999 14.8797 56.2087 18.5195 57.7164C22.1593 59.224 26.0603 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 26.0603 59.224 22.1593 57.7164 18.5195C56.2087 14.8797 53.999 11.5726 51.2132 8.7868C48.4274 6.00104 45.1203 3.79125 41.4805 2.28361C37.8407 0.775973 33.9397 0 30 0Z",
    fill: "#F82C44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectordeleteTsk);
export default __webpack_public_path__ + "static/media/VectordeleteTsk.1fa4e2224b525feb7ad729839b45b865.svg";
export { ForwardRef as ReactComponent };